import type { EdgeId } from '../edges';
import type { ReportSeverity } from '../report';
import type { PathLookupDecision } from './PathLookupDecision';

export interface PathLookupIfaceTrafficMap {
  [ifaceName: string]: EdgeId[];
}

export interface PathLookupDecisionsTrace {
  severityInfo: Record<ReportSeverity, number>;
  sourcePacketId: EdgeId;
  targetPacketId: EdgeId;
  trace: PathLookupDecision[];
}

export interface PathLookupDeviceDecisions {
  traces: PathLookupDecisionsTrace[];
  trafficIn: PathLookupIfaceTrafficMap;
  trafficOut: PathLookupIfaceTrafficMap;
}

export interface PathLookupDeviceDecisionsMap {
  [nodeId: string]: PathLookupDeviceDecisions;
}
